module.exports = __webpack_public_path__ + "img/donation-after-3.395afa35.png";